// TODO: Replace these per-accessory amounts when Slate's shipping quote service lands.
export const SELF_INSTALLED_OPTIONS_SHIPPING_COST = 500;
export const NON_FACTORY_INSTALLED_ACCESSORIES_SHIPPING_COST = 200;
export const MOCK_SELF_INSTALL_OPTION_SHIPPING_COST_PER_ACCESSORY =
  SELF_INSTALLED_OPTIONS_SHIPPING_COST;
export const MOCK_CUSTOMER_INSTALL_ONLY_SHIPPING_COST_PER_ACCESSORY =
  NON_FACTORY_INSTALLED_ACCESSORIES_SHIPPING_COST;
